import { render } from "./booking-payment-modal.vue?vue&type=template&id=6290b9b2"
import script from "./booking-payment-modal.vue?vue&type=script&lang=js"
export * from "./booking-payment-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__